// extracted by mini-css-extract-plugin
module.exports = {"img":"Banner_img__3leX4","Box":"Banner_Box__1mgAM","Baner":"Banner_Baner__txrBC"};